import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SignUp } from 'src/app/common-class/survey';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';

declare var $: any;
declare var ActiveXObject: ActiveXObject;

@Component({
  selector: 'app-sign-up',
  templateUrl: './sign-up.component.html',
  styleUrls: ['./sign-up.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignUpComponent implements OnInit {
  isUpButton: boolean;
  userEmail: string;
  response: string;
  key: string = '';

  constructor(private signUp: SignUp, private service: ParticipationDataService,
    private activatedRoute: ActivatedRoute) { }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(async params => {
      this.key = params['k'];
    });
  }


  ProcessSignUpOnEnter(event: number) {
    if (event == 13) {
      this.ProcessSignUp();
      return false;
    }
  }

  ProcessSignUp() {
    this.AjaxCall();
  }

  CloseSignUp(event) {
    event.stopPropagation();
    $(".sign-up-container-body").slideUp(500);
    $(".slide-up").css('display', 'block');
    $(".slide-down").css('display', 'none');
    $(".sign-up-container-header").attr('click', 'OpenSignUp(event);');

    if (this.isUpButton) {
      this.isUpButton = false;
    }
  }

  OpenSignUp(event) {

    if (this.service.GroupType.toLowerCase() == "preview") {
      return;
    }

    if (this.isUpButton) {
      this.CloseSignUp(event);
    } else {
      $(".sign-up-container-body").slideDown(500);
      $(".slide-up").css('display', 'none');
      $(".slide-down").css('display', 'block');
      $(".slide-up").css('display', 'none');
      $(".sign-up-container-header").attr('click', 'CloseSignUp(event);');

      if (!this.isUpButton) {
        this.isUpButton = true;
      }
    }
  }

  SignInGoogle() {
    let accountType = this.signUp.accountType;
    let signInType = this.signUp.signInType;
    var strURL = this.signUp.strHostPath.replace('http:', window.location.protocol) + "static/Intermediate/GoogleSignInProcessing.aspx?ref=" + this.signUp.ref + "&k="+ this.key +"&lang=" + this.service.getSelectedLanguage();
   
    if (accountType.length > 0){
      strURL += "&TrialAccType=" + accountType  + "&participation=1";
    }

    if (signInType) {
      window.open(strURL, '_google', 'width=505,height=585,scrollbars=yes');
    } else {
      window.open(this.signUp.strHostPath.replace('http:', window.location.protocol) + "static/Intermediate/GoogleSignInProcessing.aspx?TrialAccType=" + accountType + "&ref=" + this.signUp.ref, '_google', 'width=505,height=585,scrollbars=yes' + "&k="+ this.key +"&lang=" + this.service.getSelectedLanguage());
    }
  }

  SignInFacebook() {
    let accountType = this.signUp.accountType;
    let FaceBookID = this.signUp.FaceBookID;
    let strhost = this.signUp.strHostPath.replace('http:', window.location.protocol);
    let strURL = "https://graph.facebook.com/oauth/authorize?client_id="+ FaceBookID +"&redirect_uri=" + strhost + "static/Intermediate/FacebookIntermediate.aspx?page=4&state=" + accountType + "@ref=@timeoffset=@participation=1@lang="+ this.service.getSelectedLanguage() +"@k=" + this.key +"&scope=email&amp;display=page"
    let bw = window.open(strURL, '_facebook', 'width=1000,height=600,scrollbars=yes');
    bw.focus();
  }

  AjaxCall() {
    var xmlhttp;
    var strUrl;
    let self = this;
    if ((<any>window).XMLHttpRequest) { // code for IE7+, Firefox, Chrome, Opera, Safari
      xmlhttp = new XMLHttpRequest();
    } else { // code for IE6, IE5
      xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
    }
    xmlhttp.onreadystatechange = function () {
      if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
        document.getElementById("btnOk").style.display = 'none';
        self.response = xmlhttp.responseText;
        let labelMessage = self.parseHTML("lblMess");
        document.getElementById("error_mess").innerHTML = labelMessage;
        if (labelMessage == "sucessful") { } else if (labelMessage == "invalid") { } else if (labelMessage == "login") {
          let redirectURL = self.parseHTML("lblRedirectUrl");
          var strUrlWelcome = decodeURIComponent(redirectURL);
          strUrlWelcome = strUrlWelcome.replace(self.signUp.strParticipationServer.replace('http:', 'https:'), self.signUp.strHostPath.replace('http:', 'https:')) + "&participation=1";
          var win = window.open(strUrlWelcome, '_blank');
          win.focus();
        } else if (labelMessage.indexOf("To use the administrative features") != -1) { } else {
          if (labelMessage.indexOf("Our records indicate that you already have an account with us") != -1) {
            //document.getElementById("btnLog").style.display = '';
            //document.getElementById("a_cancel").style.display = '';
            let loginURL = self.signUp.strHostPath.replace('https:', window.location.protocol).replace('http:', window.location.protocol) + "static/login.aspx?ActMsg=21&eid=" + self.userEmail  + "&SignupByEmail=1" + "&k="+ self.key +"&lang=" + self.service.getSelectedLanguage();
            var win = window.open(loginURL, '_blank');
            win.focus();
          } else {
            document.getElementById("btnLog").style.display = 'none';
            document.getElementById("btnOk").style.display = '';
            document.getElementById("a_cancel").style.display = 'none';
            document.getElementById("overs1").style.display = "";
            document.getElementById("fadeDiv1").style.display = "";
          }          
        }
        if (document.getElementById("lblMess") == null || document.getElementById("lblMess").innerHTML != "login") { }
      }
    }
    //strUrl = this.signUp.strParticipationServer.replace('https:', window.location.protocol).replace('http:', window.location.protocol) + "static/AjaxFreesignup.aspx?isCaptcha=False&isValidate=True&istrial=0&emailaddress=" + $('#txtEmailId').val() + "&ref=&SignUpFrom=participation";
    strUrl = this.service.path + "static/AjaxFreesignup.aspx?isCaptcha=False&isValidate=True&istrial=0&emailaddress=" + $('#txtEmailId').val() + "&ref=&SignUpFrom=participation";
    xmlhttp.open("GET", strUrl + "&rnd=" + Math.random() * 9999, false);
    xmlhttp.send();
  }

  RedirectUrl() {
    let loginURL = this.signUp.strHostPath.replace('https:', window.location.protocol).replace('http:', window.location.protocol) +"static/login.aspx?ActMsg=21&eid=" + this.userEmail;
    var win = window.open(loginURL, '_blank');
    win.focus();
  }

  parseHTML(id: string) {
    let regex;
    switch (id) {
      case "lblMess":
        regex = /<span id="lblMess">(.*)<\/span>/
        break;
      case "lblAccountType":
        regex = /<span id="lblAccountType">(.*)<\/span>/
        break;
      case "lblRedirectUrl":
        regex = /<span id="lblRedirectUrl">(.*)<\/span>/
        break;
      default:
        break;
    }

    let values = this.response.match(regex);
    if (values.length > 1) {
      return values[1];
    }
  }

  CloseModal() {
    document.getElementById("overs1").style.display = "none";
    document.getElementById("fadeDiv1").style.display = "none";
  }
}
